import React from 'react';

export const KanbanViewIcon = ({ width = 16, height = 16, className = '' }) => (
  <svg
    width={width}
    height={height}
    className={className}
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M4 3.33822C3.63181 3.33822 3.33333 3.63669 3.33333 4.00488V12.0049C3.33333 12.3731 3.63181 12.6715 4 12.6715H5.33333C5.70152 12.6715 6 12.3731 6 12.0049V4.00488C6 3.63669 5.70152 3.33822 5.33333 3.33822H4ZM2 4.00488C2 2.90031 2.89543 2.00488 4 2.00488H5.33333C6.4379 2.00488 7.33333 2.90031 7.33333 4.00488V12.0049C7.33333 13.1095 6.4379 14.0049 5.33333 14.0049H4C2.89543 14.0049 2 13.1095 2 12.0049V4.00488Z"
      fill="currentColor"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M10.6667 3.33822C10.2985 3.33822 10 3.63669 10 4.00488V8.00488C10 8.37307 10.2985 8.67155 10.6667 8.67155H12C12.3682 8.67155 12.6667 8.37307 12.6667 8.00488V4.00488C12.6667 3.63669 12.3682 3.33822 12 3.33822H10.6667ZM8.66667 4.00488C8.66667 2.90031 9.5621 2.00488 10.6667 2.00488H12C13.1046 2.00488 14 2.90031 14 4.00488V8.00488C14 9.10945 13.1046 10.0049 12 10.0049H10.6667C9.5621 10.0049 8.66667 9.10945 8.66667 8.00488V4.00488Z"
      fill="currentColor"
    />
  </svg>
);
